import React, {useState, useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import '../../../css/pages/help.scss';
import helpImage from '../../../images/helpImage.png';
import Cookies from 'js-cookie';

function Help() {
    return(
        <div className='help-container'>
            <div>
                <p className='title-text'>Help</p>
                <p className='help-estimation-title'>RS11 Estimated valuation</p>
            </div>
            <div className='help-disclaimer'>
                <p>Welcome to RS11!</p>
                <p>We’re attempting to estimate the value of every small and medium size business (SMB) in the US without input from its owners. A difficult task when considering there are over 30 million SMBs.</p>
                <p>This Beta version is a work in progress, so please know our valuations exclude real estate values and may be inaccurate. Some SMBs are yet to be valued, while others are already out of business. As we continue to invest more money and time into our startup, our estimated valuations will continue to improve.</p>
                <p>The world wasn’t built in a day, so thank you for joining us on this exciting journey.</p>
            </div>
            <div className='help-content'>
                <p className='question-text'>What is RS11?</p>
                <div className='grid-image-text'>
                    <div>
                        <p className='content-text-grid'>RS11 strives to help small and medium size businesses by providing estimated business valuations, actionable data and support.</p>
                        <p className='content-text'>Using a combination of public and private data, machine learning and artificial intelligence, RS11 provides free estimated valuations of small and medium size businesses (SMBs). Our valuations do not include the value of real estate, existing contracts or inventory. The AI-derived estimated valuations are what we think would be the price of business if it were sold.</p>
                        <p className='content-text'>RS11 will be adding financial services, the ability to buy and sell, benchmarking and more in the very near future. Our goal is to help SMB owners achieve their financial goals with trusted partners.</p>
                        <p className='content-text'>RS11 is headquartered in Cupertino, CA, in the heart of Silicon Valley. It also has offices in Boston and India.</p>
                    </div>
                    <img className='help-image-grid' src={helpImage} />
                </div>
            </div>
            <div className='help-content'>
                <p className='question-text'>Where does RS11 get information about my business?</p>
                <p className='content-text'>RS11 uses local, state and national government data, census data, and proprietary information. RS11 believes in a give-get model, as well, where we provide SMB owners with actional data in exchange for more information about their business.</p>
            </div>
            <div className='help-content'>
                <p className='question-text'>How do I report what I consider to be incorrect data?</p>
                <p className='content-text'>
                    <span>If you believe any information or estimate is wrong, please email us at </span>
                    <a className='support-text' href = "mailto:support@rs11.com">support@rs11.com </a>
                    <span>and provide:</span>
                </p>
                <div className='detail-text'>
                    <p>The name of the business</p>
                    <p>Your name</p>
                    <p>Your relationship to the business (i.e. owner, customer, vendor, etc.)</p>
                    <p>What you believe to be incorrect</p>
                </div>
                <p className='question-text'>RS11’s support team will review the request and keep you apprised of any updates or questions.</p>
            </div>
            <div className='help-content'>
                <p className='question-text'>Can I have my business removed from RS11?</p>
                <p className='content-text'>RS11’s goal is to provide an estimated valuation for every SMB in the United States. Our mission is to help SMB owners increase the valuation of their businesses and provide transparency to an often-convoluted process. For these reasons, we do not remove properties from RS11.</p>
                <p className='content-text'>
                    <span>If you believe there are errors in the estimated valuation or business information, report the issue </span>
                    <a className='support-text' href = "mailto:support@rs11.com">here</a>
                    <span>.</span>
                </p>
            </div>
        </div>
    )
}

export default Help;